import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar, { Nav } from "../../nav/Navbar";
import Brand from "../../brand/Brand";

// Menu content
const menuContent = [
    { name: "Portfolio", to: "/portfolio" },
    { name: "About", to: "/#about" },
    { name: "Contact", to: "/contact" },
];

const AlicjaMenu = ({ hamburger }) => {
    const navigate = useNavigate();
    const location = useLocation();
    let $key = 0;

    const scrollToAbout = () => {
        const section = document.getElementById("about");
        if (section) {
            const offset = 80;
            const top = section.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top, behavior: "smooth" });
        }
    };

    const handleAboutClick = (e) => {
        e.preventDefault();

        if (location.pathname === "/") {
            scrollToAbout();
        } else {
            navigate("/#about");
        }
    };

    const getSubMenu = (items) => {
        $key++;

        if (items.dropdownMenu) {
            return (
                <Nav.Dropdown name={items.name} key={$key}>
                    {items.dropdownMenu.map(item => getSubMenu(item))}
                </Nav.Dropdown>
            );
        }

        if (items.name === "About") {
            return (
                <Nav.Link
                    to="#about"
                    key={$key}
                    onClick={handleAboutClick}
                >
                    {items.name}
                </Nav.Link>
            );
        }

        return (
            <Nav.Link
                to={items.to}
                key={$key}
            >
                {items.name}
            </Nav.Link>
        );
    };

    return (
        <Navbar>
            <Navbar.Brand to={"/"}>
                <Brand width="40px" height="40px" />
            </Navbar.Brand>

            <Navbar.Collapse cover="Menu">
                <Nav>
                    {menuContent.map(item => getSubMenu(item))}
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
};

AlicjaMenu.defaultProps = {
    hamburger: false
};

export default AlicjaMenu;
